import { useDistributorData } from '../../hooks/use-distributor-data';
import { useSolana } from '../../providers/solana';
import Claim from '../claim';
import Token24Icon from '@/assets/svgs/Token24Icon.svg';
import Image from 'next/image';
import React from 'react';
import { SolanaSubLogin } from '@/components/connect-wallet/container';

const Home = () => {
  const {
    connection,
    provider,
    program,
    ctx,
    distributorClient,
    mintPublicKey,
    merkleTreeVersion,
    distributor,
    publicKey,
    connected,
  } = useSolana();
  const { data: distributorData } = useDistributorData();

  const isAirdropEnded = (distributorData?.endTs ?? 0) < Date.now() / 1000;

  if (
    !connection ||
    !provider ||
    !program ||
    !ctx ||
    !distributorClient ||
    !mintPublicKey ||
    !merkleTreeVersion ||
    !distributor ||
    !publicKey
  ) {
    return <div>Loading...</div>;
  }
  return (
    <div
      className={
        'flex flex-col items-center w-full md:px-0 lg:px-[40px] font-ms_serif'
      }
    >
      <div
        className={
          'flex-1 flex flex-col md:flex-row gap-[12px] md:gap-[24px] justify-center md:py-[40px] max-md:max-w-[500px] w-full'
        }
      >
        <div
          className={'absolute top-0 left-0 w-screen h-full'}
          style={{
            background: `linear-gradient(180deg, #0E0B10 19.63%, #300E46 44.79%, #4C1771 69.11%, #8A31C6 100%), linear-gradient(180deg, #0D0810 19.63%, #311246 44.79%, #4A0D72 69.11%, #9532D7 100%), linear-gradient(180deg, var(--color-background-gradient-default-1, #100D08) 75%, var(--color-yellow-yl08, #282001) 100%)`,
          }}
        />
        <div
          className={'absolute top-0 left-0 w-screen h-full'}
          style={{
            backgroundImage: "url('/images/claim-background.png')",
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'bottom center',
            opacity: 0.25,
            mixBlendMode: 'luminosity',
          }}
        />
        <div
          className={
            'px-[20px] py-[24px] md:pr-0  lg:px-[64px] md:max-w-[300px] lg:max-w-[613px] w-full flex flex-col gap-[20px] md:gap-[24px] z-[1]'
          }
        >
          <div className="relative inline-block text-[40px] leading-[44px] lg:text-[72px] lg:leading-[120%]">
            <div className="absolute inset-0 text-shadow-48 lg:text-shadow-612 text-nowrap text-left">
              PHASE 3
              <br />
              CLAIM
            </div>

            {/* Layer 2: gradient */}
            <div className="relative text-transparent bg-clip-text bg-gradient-to-b from-[#F0E9CF] to-[#F1C315] text-nowrap text-left">
              PHASE 3
              <br />
              CLAIM
            </div>
          </div>
          <div
            className={
              'grid grid-cols-2 md:grid-cols-1 gap-[20px] md:gap-[24px]'
            }
          >
            <div className={'flex flex-col gap-[12px]'}>
              <div
                className={
                  'text-[#f0e9cf7a] text-[12px] leading-[16px] md:text-[16px] md:leading-[20px]'
                }
              >
                Claim Deadline
              </div>
              <div
                className={
                  'flex flex-row gap-[8px] items-center text-[#F0E9CF] text-[16px] leading-[22px] md:text-[20px] md:leading-[24px]'
                }
              >
                <div className={'mt-[2px]'}>3 PM UTC, Sep 25</div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={
            'flex flex-col justify-center max-w-[500px] w-full lg:w-[500px] px-[8px] pb-[20px] md:pb-0 md:pl-0 md:pr-[20px] lg:p-0 z-[1]'
          }
        >
          <div className={'pixel-border px-[3px] py-[7px] md:p-[7px]'}>
            {connected && <Claim />}
            {!connected && <SolanaSubLogin />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
